import { CalculateVenueCo2 } from '@/domain/impact-calculate-venue/entities/calculate-venue-co2.entity';
import { translate } from '@/ui/i18n';
import { TopicScoreDetailsData } from '@/ui/pages/app/components/topic-score-card/type';

export function prepareVenueTopicScoreDetailsDataCo2(
  calculateVenueCo2: CalculateVenueCo2,
): TopicScoreDetailsData {
  const structureCo2Score = calculateVenueCo2.structure;
  return {
    value: structureCo2Score.score,
    refValue: NaN,
    maxValue: NaN,
    completion: NaN,
    sections: [
      {
        name: translate('Projects.team'),
        sector: 'TEAM',
        items: [
          {
            id: 'transport',
            name: translate('Co2.Sections.TRANSPORT'),
            value: structureCo2Score.sectors.team.categories.transport.score,
            unit: 'teCO2',
          },
          {
            id: 'catering',
            name: translate('Co2.Sections.CATERING'),
            value: structureCo2Score.sectors.team.categories.catering.score,
            unit: 'teCO2',
          },
        ],
      },
      {
        name: translate('Projects.public'),
        sector: 'PUBLIC',
        items: [
          {
            id: 'catering',
            name: translate('Co2.Sections.CATERING'),
            value: structureCo2Score.sectors.public.categories.catering.score,
            unit: 'teCO2',
          },
          {
            id: 'digital',
            name: translate('Co2.Sections.DIGITAL'),
            value: structureCo2Score.sectors.public.categories.digital.score,
            unit: 'teCO2',
          },
        ],
      },
      {
        name: translate('Projects.site'),
        sector: 'SITE',
        items: [
          {
            id: 'scenography',
            name: translate('Co2.Sections.SCENOGRAPHY'),
            value: structureCo2Score.sectors.site.categories.scenography.score,
            unit: 'teCO2',
          },
          {
            id: 'material',
            name: translate('Co2.Sections.MATERIAL'),
            value: structureCo2Score.sectors.site.categories.material.score,
            unit: 'teCO2',
          },
          {
            id: 'building',
            name: translate('Co2.Sections.BUILDING'),
            value: structureCo2Score.sectors.site.categories.building.score,
            unit: 'teCO2',
          },
          {
            id: 'energy',
            name: translate('Co2.Sections.ENERGY'),
            value: structureCo2Score.sectors.site.categories.energy.score,
            unit: 'teCO2',
          },
          {
            id: 'water',
            name: translate('Co2.Sections.WATER'),
            value: structureCo2Score.sectors.site.categories.water.score,
            unit: 'teCO2',
          },
          {
            id: 'waste',
            name: translate('Co2.Sections.WASTE'),
            value: structureCo2Score.sectors.site.categories.waste.score,
            unit: 'teCO2',
          },
          {
            id: 'equipment',
            name: translate('Co2.Sections.EQUIPMENT'),
            value: structureCo2Score.sectors.site.categories.equipment.score,
            unit: 'teCO2',
          },
        ],
      },
    ],
  };
}
